import { commonViewTexts as c } from '../common';

export const projectImageSettingsDialogViewTexts = {
  title: `${c.blueprint}設定`,
  subTitle: `${c.model}と${c.blueprint}名を入力してください。`,
  label1: c.model,
  label2: '階数入力',
  label3: `${c.blueprint}名`,
  autoCompleteButton: `${c.blueprint}名を自動入力`,
  cancel: c.cancel,
  ok: c.save,
  redirectPage: {
    title: 'この図面に使用できる学習済みモデルが存在しません',
    description:
      '推論モデル一覧に移動し、先に推論モデルの作成・学習を実行してください。',
    goToModelList: `${c.model}一覧へ移動`
  }
} as const;
